/* Black Friday mode: picks the current calendar entry (snippets/jy-bf-schedule,
   Morocco time) and drives the top bar + home hero texts and countdowns.
   Only loaded while the mode is live. */
(function () {
  'use strict';
  var TZ = '+01:00';
  var at = function (s) { return Date.parse(s.length === 16 ? s + ':00' + TZ : s); };
  var sched = [];
  try { sched = JSON.parse((document.getElementById('jy-bf-schedule') || {}).textContent || '[]'); } catch (e) { sched = []; }
  var html = document.documentElement;
  var ar = (html.getAttribute('lang') || '').indexOf('ar') === 0;
  var strings = {};
  var tpl = document.querySelector('template[data-jy-bf-strings]');
  if (tpl) Array.prototype.forEach.call(tpl.content.querySelectorAll('i[data-k]'), function (i) { strings[i.getAttribute('data-k')] = i.textContent.trim(); });
  var dayUnit = strings._d || 'j';
  var DOW = ar ? ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'] : ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MON = ar ? ['يناير', 'فبراير', 'مارس', 'أبريل', 'ماي', 'يونيو', 'يوليوز', 'غشت', 'شتنبر', 'أكتوبر', 'نونبر', 'دجنبر'] : ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var SLOTS = [20]; /* one Black Flash a day, 20:00 – 21:00 */
  var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
  var fmt = function (ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    return (d ? d + dayUnit + ' ' : '') + p2(Math.floor(s / 3600)) + ':' + p2(Math.floor(s / 60) % 60) + ':' + p2(s % 60);
  };
  // Morocco wall-clock parts of a timestamp
  var mor = function (ms) { var d = new Date(ms + 3600000); return { y: d.getUTCFullYear(), m: d.getUTCMonth(), d: d.getUTCDate(), w: d.getUTCDay(), h: d.getUTCHours() }; };
  var dayAt = function (ms, h) { var m = mor(ms); return Date.UTC(m.y, m.m, m.d, h) - 3600000; };

  function current(now) {
    for (var i = 0; i < sched.length; i++) {
      var e = sched[i];
      if (now >= at(e.from) && now < at(e.to)) return e;
    }
    return null;
  }
  // flash day: live slot, next slot or done
  function flash(now) {
    for (var i = 0; i < SLOTS.length; i++) {
      var st = dayAt(now, SLOTS[i]);
      if (now >= st && now < st + 3600000) return { live: true, i: i, target: st + 3600000 };
      if (now < st) return { live: false, i: i, target: st };
    }
    /* today's slot is over: count down to tomorrow's when tomorrow is a Black Flash day too */
    var next = dayAt(now + 86400000, SLOTS[0]), ne = current(next);
    if (ne && ne.k === 'flash') return { live: false, i: 0, target: next, tomorrow: true };
    return { live: false, i: SLOTS.length, target: 0 };
  }

  var bar = document.querySelector('[data-jy-bf-bar]');
  var hero = document.querySelector('[data-jy-bf-hero]');
  var tone = { teaser: 'dark', teaser_cat: 'dark', guess: 'red', drop: 'red', drop_live: 'red', weekend: 'cream', second: 'green', cat: 'dark', onedh_tease: 'dark', onedh_reveal: 'dark', onedh_sale: 'dark', final: 'red', rest: 'dark', after: 'dark' };

  function tick() {
    var now = Date.now();
    var e = current(now);
    var k = e ? e.k : 'rest';
    var target = e && e.t ? at(e.t) : e ? at(e.to) : 0;
    var barKey = k, live = false, f = null;
    if (k === 'flash') {
      f = flash(now);
      live = f.live; target = f.target;
      barKey = live ? 'flash_live' : f.target ? 'flash' : 'rest';
    } else if (k === 'drop' && target && now >= target) {
      barKey = 'drop_live'; target = 0;
    }
    if (k === 'rest' || k === 'after' || k === 'onedh_sale') target = 0;
    // page-wide state for CSS: the kind of day, and whether it's a big offer day
    // (the tier discounts are paused by the worker on those days)
    var kc = 'jy-bf-k-' + k;
    if (!html.classList.contains(kc)) {
      Array.prototype.slice.call(html.classList).forEach(function (c) { if (c.indexOf('jy-bf-k-') === 0) html.classList.remove(c); });
      html.classList.add(kc);
      html.classList.toggle('jy-bf-big', ['flash', 'drop', 'weekend', 'second', 'cat', 'onedh_sale', 'final'].indexOf(k) !== -1);
    }
    if (target && target <= now) target = 0;

    if (bar) {
      bar.setAttribute('data-tone', live || barKey === 'flash' ? '' : (tone[barKey] || ''));
      var txt = bar.querySelector('[data-jy-bf-bartxt]');
      var cd = bar.querySelector('[data-jy-bf-barcd]');
      var dot = bar.querySelector('[data-jy-bf-live]');
      if (txt && strings[barKey]) txt.textContent = strings[barKey];
      if (cd) cd.textContent = target ? fmt(target - now) : '';
      if (dot) dot.hidden = !live;
      if (e && e.url) bar.href = e.url.indexOf('://') !== -1 ? e.url : (bar.getAttribute('data-root') || '') + e.url;
    }
    if (hero) {
      var shown = null;
      Array.prototype.forEach.call(hero.querySelectorAll('[data-k]'), function (p) {
        var on = p.getAttribute('data-k') === k;
        if (p.hidden === on) p.hidden = !on;
        if (on) shown = p;
      });
      if (shown) {
        var kick = shown.querySelector('[data-jy-bf-kicker]');
        if (kick && e) {
          var a = mor(at(e.from)), b = mor(at(e.to) - 1);
          var txtk = a.d === b.d && a.m === b.m ? DOW[a.w] + ' ' + p2(a.d) + ' ' + MON[a.m] : p2(a.d) + ' – ' + p2(b.d) + ' ' + MON[b.m];
          if (kick.textContent !== txtk) kick.textContent = txtk;
        }
        var title = shown.querySelector('[data-jy-bf-title]');
        var ov = e && (ar ? e.title_ar : e.title_fr);
        if (title && ov && title.textContent !== ov) title.textContent = ov;
        var cta = shown.querySelector('[data-jy-bf-cta]');
        if (cta && e && e.url) cta.href = e.url.indexOf('://') !== -1 ? e.url : (hero.getAttribute('data-root') || '') + e.url;
        var rb = shown.querySelector('[data-jy-bf-remind]');
        if (rb) {
          var rt = target && target > now && !(f && f.live) ? target : 0;
          rb.hidden = !rt;
          if (rt) {
            var mo = mor(rt), atS = mo.y + '-' + p2(mo.m + 1) + '-' + p2(mo.d) + 'T' + p2(mo.h) + ':' + p2(new Date(rt + 3600000).getUTCMinutes());
            if (rb.getAttribute('data-at') !== atS) {
              rb.setAttribute('data-at', atS);
              rb.setAttribute('data-label', (rb.getAttribute('data-label-base') || 'Black Friday') + ' ' + atS.slice(11));
              if (window.JYBF && JYBF.paintRemind) JYBF.paintRemind(shown);
            }
          }
        }
        var cw = shown.querySelector('[data-jy-bf-clockwrap]');
        if (cw) {
          cw.hidden = !target;
          var c = cw.querySelector('[data-jy-bf-clock]');
          if (c) c.textContent = target ? fmt(target - now) : '';
          var lab = cw.querySelector('[data-jy-bf-clocklabel][data-live]');
          if (lab && f) { var want = f.live ? lab.getAttribute('data-live') : lab.getAttribute('data-next'); if (lab.textContent !== want) lab.textContent = want; }
        }
        if (f) {
          Array.prototype.forEach.call(shown.querySelectorAll('[data-jy-bf-slots] span'), function (s, i) {
            var state = f.i >= SLOTS.length || i < f.i ? 'done' : i === f.i && f.live ? 'live' : 'next';
            s.className = state === 'live' ? 'is-live' : state === 'done' ? 'is-done' : '';
            var sm = s.querySelector('small');
            if (sm) sm.textContent = strings['slot_' + state] || '';
          });
        }
      }
    }
  }
  tick();
  setInterval(tick, 1000);

  /* order confirmation: the next appointment of the calendar */
  var nx = document.querySelector('[data-jy-bf-next]');
  if (nx) {
    var n0 = Date.now(), best = null;
    var consider = function (t, k) {
      var h = mor(t).h;
      if (h < 9 || h > 22) return; // no night-time appointments
      if (t > n0 + 60000 && (!best || t < best.t)) best = { t: t, k: k };
    };
    sched.forEach(function (e) {
      if (e.k === 'rest' || e.k === 'after') return;
      if (e.k === 'flash') {
        for (var d = at(e.from); d < at(e.to); d += 86400000) SLOTS.forEach(function (h) { consider(dayAt(d + 3600000, h), 'flash'); });
      } else {
        consider(at(e.from) + 10 * 3600000, e.k); // 10:00 on the day it starts
        if (e.t) consider(at(e.t), e.k);
      }
    });
    if (best) {
      var mm = mor(best.t), mins = p2(new Date(best.t + 3600000).getUTCMinutes());
      var hhmm = p2(mm.h) + ':' + mins;
      var sameDay = mor(n0).d === mm.d;
      var whenTxt = (sameDay ? (ar ? 'اليوم' : 'Aujourd’hui') : DOW[mm.w] + ' ' + p2(mm.d) + ' ' + MON[mm.m]) + ' · ' + hhmm;
      nx.querySelector('[data-jy-bf-next-t]').textContent = (strings['short_' + best.k] || 'Black Friday') + ' · ' + whenTxt;
      nx.querySelector('[data-jy-bf-next-s]').textContent = strings['sub_' + best.k] || '';
      var rbt = nx.querySelector('[data-jy-bf-remind]');
      var atStr = mm.y + '-' + p2(mm.m + 1) + '-' + p2(mm.d) + 'T' + hhmm;
      rbt.setAttribute('data-at', atStr);
      rbt.setAttribute('data-label', (strings['short_' + best.k] || 'Black Friday') + ' ' + hhmm);
      if (best.k === 'flash') rbt.setAttribute('data-path', '/pages/black-flash');
      nx.hidden = false;
    }
  }

  /* mobile menu: today's offer under "Black Friday" */
  var mt = document.querySelector('[data-jy-bf-menu-today]');
  var cur0 = current(Date.now());
  if (mt && cur0 && strings['short_' + cur0.k]) mt.textContent = (ar ? 'اليوم: ' : 'Aujourd’hui : ') + strings['short_' + cur0.k];

  /* ---------- weekly game popup: once a day, after 8 s, never on product /
     cart / checkout / Black Friday pages, nor over another open dialog ---------- */
  (function () {
    var pop = document.querySelector('template[data-jy-bf-gpop]');
    if (!pop || window.JY_IS_APP === true) return;
    /* never inside the Black Friday world (deals, 2+1, product view) nor where the game already is */
    if (document.documentElement.classList.contains('jy-bfw') || document.querySelector('[data-jy-bfg]')) return;
    var body = document.body.className || '';
    if (/\b(product|cart)-template\b/.test(body) || /\/pages\/(black-|mon-compte|merci)/.test(location.pathname) || /\/checkout/.test(location.pathname)) return;
    var day = new Date(Date.now() + 3600000).toISOString().slice(0, 10);
    try { if (localStorage.getItem('jy_bf_gpop') === day) return; } catch (e) { return; }
    setTimeout(function () {
      if (document.querySelector('dialog[open], .jy-wheel.is-open, [data-jy-wheel-dialog]:not([hidden]), .jy-bf-sheet:not([hidden])')) return;
      try { localStorage.setItem('jy_bf_gpop', day); } catch (e) { /* noop */ }
      var wrap = document.createElement('div');
      wrap.appendChild(pop.content.cloneNode(true));
      var el = wrap.firstElementChild;
      document.body.appendChild(el);
      var close = function () { el.remove(); document.documentElement.classList.remove('jy-bf-sheet-open'); };
      el.addEventListener('click', function (e) { if (e.target.closest('[data-x]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      var cd = el.querySelector('[data-jy-gpop-cd]');
      if (cd) {
        var d = new Date(Date.now() + 3600000), dow = (d.getUTCDay() + 6) % 7;
        var end = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() - dow + 7) - 3600000;
        var t = function () { var s2 = Math.max(0, Math.floor((end - Date.now()) / 1000)); var dd = Math.floor(s2 / 86400); s2 -= dd * 86400; cd.textContent = dd + dayUnit + ' ' + p2(Math.floor(s2 / 3600)) + ':' + p2(Math.floor(s2 / 60) % 60); };
        t(); setInterval(t, 30000);
      }
      var go = el.querySelector('a');
      if (go) go.focus();
    }, 8000);
  })();

  /* ---------- "remind me on WhatsApp" (any [data-jy-bf-remind] button) ----------
     data-at = calendar event (Morocco time "YYYY-MM-DDTHH:MM"), data-label =
     what the message names, data-path = page the message links to. One phone
     sheet for the whole site; the phone is remembered on this device. */
  var EP = window.JY_COD_ENDPOINT ? String(window.JY_COD_ENDPOINT).replace(/\/+$/, '') : '';
  var remKey = 'jy_bf_rem';
  var remSet = {};
  try { (JSON.parse(localStorage.getItem(remKey) || '[]') || []).forEach(function (a) { remSet[a] = 1; }); } catch (e) { /* noop */ }
  function savedPhone() {
    try {
      var c = JSON.parse(localStorage.getItem('jy_cod_customer') || 'null');
      if (c && c.phone) return c.phone;
      return localStorage.getItem('jy_portal_phone') || localStorage.getItem('jy_bf_phone') || '';
    } catch (e) { return ''; }
  }
  /* data-ep="/bf/wait" + data-slot turns the same button into a waitlist
     sign-up; data-txt / data-txt-on override the labels */
  var remId = function (btn) { return (btn.getAttribute('data-ep') || '') + (btn.getAttribute('data-at') || btn.getAttribute('data-slot') || ''); };
  function paintRemind(btn) {
    var on = !!remSet[remId(btn)];
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var l = btn.querySelector('[data-jy-bf-remind-l]') || btn;
    l.textContent = on ? btn.getAttribute('data-txt-on') || strings.rem_on : btn.getAttribute('data-txt') || strings.rem_btn;
  }
  window.JYBF = window.JYBF || {};
  window.JYBF.savedPhone = savedPhone;
  window.JYBF.paintRemind = function (scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-jy-bf-remind]'), paintRemind); };
  window.JYBF.paintRemind();
  var sheet = null;
  function openSheet(btn) {
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.className = 'jy-bf-sheet';
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      sheet.innerHTML = '<div class="jy-bf-sheet__scrim" data-x></div><form class="jy-bf-sheet__box" novalidate>' +
        '<button type="button" class="jy-bf-sheet__close" data-x aria-label="×">×</button>' +
        '<b class="jy-bf-sheet__t"></b><p class="jy-bf-sheet__s"></p>' +
        '<label class="jy-bf-sheet__f"><span></span><input type="tel" inputmode="tel" autocomplete="tel" dir="ltr" required></label>' +
        '<p class="jy-bf-sheet__err" role="alert" hidden></p>' +
        '<button type="submit" class="jy-bf-sheet__go"></button></form>';
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (e) { if (e.target.closest('[data-x]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && !sheet.hidden) close(); });
      sheet.querySelector('form').addEventListener('submit', submit);
    }
    sheet._btn = btn;
    sheet.querySelector('.jy-bf-sheet__t').textContent = btn.getAttribute('data-sheet-t') || strings.rem_title || '';
    sheet.querySelector('.jy-bf-sheet__s').textContent = btn.getAttribute('data-sheet-s') || (strings.rem_sub || '').replace('{t}', btn.getAttribute('data-label') || '');
    sheet.querySelector('.jy-bf-sheet__f span').textContent = strings.rem_phone || '';
    sheet.querySelector('.jy-bf-sheet__go').textContent = strings.rem_send || '';
    sheet.querySelector('.jy-bf-sheet__err').hidden = true;
    var inp = sheet.querySelector('input');
    inp.value = savedPhone();
    sheet.hidden = false;
    document.documentElement.classList.add('jy-bf-sheet-open');
    setTimeout(function () { inp.focus(); }, 30);
  }
  function close() {
    if (!sheet) return;
    sheet.hidden = true;
    document.documentElement.classList.remove('jy-bf-sheet-open');
    if (sheet._btn) sheet._btn.focus();
  }
  function send(btn, phone, off) {
    var ep = btn.getAttribute('data-ep') || '/bf/remind';
    return fetch(EP + ep, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: phone, at: btn.getAttribute('data-at') || undefined, slot: btn.getAttribute('data-slot') || undefined, label: btn.getAttribute('data-label') || '', path: btn.getAttribute('data-path') || '', lang: ar ? 'ar' : 'fr', off: off || undefined })
    }).then(function (r) { return r.json(); });
  }
  function store() { try { localStorage.setItem(remKey, JSON.stringify(Object.keys(remSet))); } catch (e) { /* noop */ } }
  function submit(e) {
    e.preventDefault();
    var btn = sheet._btn, inp = sheet.querySelector('input'), err = sheet.querySelector('.jy-bf-sheet__err');
    var d = inp.value.replace(/[^\d]/g, '');
    var n9 = d.slice(-9);
    if (!/^[567]\d{8}$/.test(n9)) { err.textContent = strings.rem_bad || ''; err.hidden = false; inp.focus(); return; }
    var go = sheet.querySelector('.jy-bf-sheet__go');
    go.disabled = true;
    send(btn, '0' + n9).then(function (j) {
      go.disabled = false;
      if (!j || !j.ok) throw new Error((j && j.error) || 'x');
      try { localStorage.setItem('jy_bf_phone', '0' + n9); } catch (x) { /* noop */ }
      remSet[remId(btn)] = 1;
      store();
      window.JYBF.paintRemind();
      close();
    }).catch(function () { go.disabled = false; err.textContent = strings.rem_err || ''; err.hidden = false; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jy-bf-remind]');
    if (!btn || !EP) return;
    e.preventDefault();
    var id = remId(btn);
    if (!btn.getAttribute('data-at') && !btn.getAttribute('data-slot')) return;
    if (remSet[id]) {
      if (btn.getAttribute('data-ep')) return; // a waitlist place isn't given back from here
      var ph = savedPhone();
      delete remSet[id];
      store();
      paintRemind(btn);
      if (ph) send(btn, ph, true).catch(function () {});
      return;
    }
    openSheet(btn);
  });

  /* product page: Black Friday box (snippets/jy-bf-pdpbox) — countdown to the
     end of BF, −% follows the selected variant, steps aside for a Flash box */
  var pb = document.querySelector('[data-jy-bfpb]');
  if (pb) {
    var pbEnd = pb.getAttribute('data-end') ? at(pb.getAttribute('data-end')) : NaN;
    var pbCdWrap = pb.querySelector('[data-jy-bfpb-cdwrap]');
    var pbCd = pb.querySelector('[data-jy-bfpb-cd]');
    if (pbEnd && !isNaN(pbEnd) && pbCd) {
      var pbTick = function () {
        var left = pbEnd - Date.now();
        if (left <= 0) { pbCdWrap.hidden = true; clearInterval(pbIv); return; }
        pbCdWrap.hidden = false;
        pbCd.textContent = fmt(left);
      };
      var pbIv = setInterval(pbTick, 1000);
      pbTick();
    }
    var pbOff = pb.querySelector('[data-jy-bfpb-off]');
    var srcOff = document.querySelector('[data-jy-off]');
    if (pbOff && srcOff && window.MutationObserver) {
      var syncOff = function () {
        var m = (srcOff.textContent || '').match(/(\d+)/);
        if (srcOff.hidden || !m || m[1] === '0') { pbOff.hidden = true; return; }
        pbOff.hidden = false;
        pbOff.textContent = '\u2212' + m[1] + '%';
      };
      new MutationObserver(syncOff).observe(srcOff, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }
    document.addEventListener('jy:bf:flashbox', function () { pb.hidden = true; });
  }


  /* product page: this product is in a live Black Flash slot → show its price */
  var priceEl = document.querySelector('.jy-pdp__price');
  var pidEl = priceEl && priceEl.closest('[data-product-id]');
  var pid = pidEl ? pidEl.getAttribute('data-product-id') : (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product ? String(ShopifyAnalytics.meta.product.id) : '');
  if (priceEl && pid && window.JY_COD_ENDPOINT) {
    fetch(String(window.JY_COD_ENDPOINT).replace(/\/+$/, '') + '/bf/flash', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok || !j.slots) return;
        var skew = j.now ? j.now - Date.now() : 0;
        var hit = null, slot = null;
        j.slots.forEach(function (s) {
          if (s.state !== 'live' || !s.items) return;
          s.items.forEach(function (it) { if (String(it.p) === String(pid) && !it.soldout) { hit = it; slot = s; } });
        });
        if (!hit) return;
        /* LTR isolate so "199 DH" keeps its order inside Arabic text */
        var money = function (v) { return '\u2066' + (Math.round(v * 100) % 100 ? v.toFixed(2) : String(Math.round(v))) + ' DH\u2069'; };
        var box = document.createElement('div');
        box.className = 'jy-bf-pdp';
        box.innerHTML = '<div class="jy-bf-pdp__top"><b></b><b dir="ltr" class="jy-bf-pdp__cd"></b></div><div class="jy-bf-pdp__bar" aria-hidden="true"><i></i></div><small class="jy-bf-pdp__sub"></small>';
        box.querySelector('.jy-bf-pdp__top > b').textContent = strings.pdp_title || strings.pdp_ends || '';
        var sold = hit.qty > 0 ? Math.max(0, Math.min(100, Math.round(((hit.sold || 0) * 100) / hit.qty))) : -1;
        if (sold < 0) box.querySelector('.jy-bf-pdp__bar').remove();
        else box.querySelector('.jy-bf-pdp__bar i').style.width = Math.max(4, sold) + '%';
        box.querySelector('.jy-bf-pdp__sub').textContent = [sold >= 0 && strings.pdp_sold ? strings.pdp_sold.replace('{n}', sold) : '', strings.pdp_one || '', strings.pdp_after ? strings.pdp_after.replace('{r}', money(hit.regular)) : ''].filter(Boolean).join(' · ');
        priceEl.parentNode.insertBefore(box, priceEl.nextSibling);
        document.dispatchEvent(new CustomEvent('jy:bf:flashbox', { detail: { price: hit.price, regular: hit.regular } }));
        var cd = box.querySelector('.jy-bf-pdp__cd');
        var t = function () {
          var left = slot.end - (Date.now() + skew);
          if (left <= 0) { box.remove(); clearInterval(iv); return; }
          cd.textContent = fmt(left);
        };
        var iv = setInterval(t, 1000);
        t();
      })
      .catch(function () { /* no box */ });
  }
})();
